import { useBillingStatus } from "@hooks/useBillingStatus";
import { FLAT_RATE_PLANS } from "@common/flatRateBilling";

export function useFullChartOfAccounts() {
    const { isSubscribed, currentPlan } = useBillingStatus();

    return (
        isSubscribed &&
        [FLAT_RATE_PLANS.PLUS, FLAT_RATE_PLANS.ENTERPRISE].includes(currentPlan)
    );
}
